import { get, writable } from "svelte/store";
import RangeRing from "../RangeRing/RangeRing";

const RangeRingStore = {
	meta: {
		lastUpdated: writable(0)
	},
	items: writable([]),
	actions: {
		add: () => {
			let items = get(RangeRingStore.items);
			items = [
				...items,
				new RangeRing(items.length)
			];
			RangeRingStore.items.set(items);
			RangeRingStore.meta.lastUpdated.set(Date.now());
		},
		setTop: (lng, lat, time, speed) => {
			let items = get(RangeRingStore.items);
			if (items.length === 0) {
				console.warn("setTop called when array.length = 0");
				return;
			}

			const item = items.splice(items.length - 1, 1)[0];
			item.input.lng.set(lng);
			item.input.lat.set(lat);
			item.input.time.set(time);
			item.input.speed.set(speed);
			RangeRingStore.helpers.recalculate(item);

			items = [
				...items,
				item
			];
			RangeRingStore.items.set(items);
			RangeRingStore.meta.lastUpdated.set(Date.now());
		},
		clearAll: () => {
			RangeRingStore.items.set([]);
			RangeRingStore.meta.lastUpdated.set(Date.now());
		},
		reset: () => {
			RangeRingStore.actions.clearAll();
			RangeRingStore.actions.add();
			RangeRingStore.meta.lastUpdated.set(Date.now());
		}
	},
	helpers: {
		recalculateAll: () => {
			const items = get(RangeRingStore.items);
			const count = items.length;
			for (let i = 0; i < count; i++) {
				const item = items[i];
				RangeRingStore.helpers.recalculate(item);
			}
		},
		recalculate: (item) => {
			item.recalculate();
		}
	}
};
export default RangeRingStore;
